import { ConnectionState } from '../constants';

export default (state: string) => state === ConnectionState.connected;
